<ion-item>
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col size="6">
        <ion-skeleton-text
          [animated]="true"
          style="width: 60%; height: 1rem"
        ></ion-skeleton-text>
      </ion-col>
      <ion-col size="6">
        <ion-skeleton-text
          [animated]="true"
          style="width: 30%; height: 1rem; justify-self: end"
        ></ion-skeleton-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-item>
